export class Sort {
  public label?: string;
  public sortKey: string;
  public ascending: boolean;

  constructor(sortKey?: string, ascending?: boolean) {
    this.sortKey = sortKey;
    this.ascending = ascending;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/sort.ts